<template>
  <v-app>
    <v-main>
      <Menu></Menu>  
      <router-view :key="$route.fullPath"/>
      <div class="modal-backdrop" id="modal-backdrop" v-if='banner.displayBanner' ></div>
      <div class="modal" id="modal" v-if='banner.displayBanner' > 
        <img 
          class="modal-image" 
          :src='banner.imageUrl' 
          alt="Patio Dining Set"
        >
        <div class="modal-inner">
          <div class="modal-content">
            <h2 class="modal-title">{{banner.header}}</h2>
            <p class="modal-text">{{banner.body}}</p>
          </div>
          <button id="closeModal" :to='banner.redirectUrl' @click="hideModal" v-if="banner.showButton" >{{banner.buttonLabel}}</button>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Menu from './components/Menu.vue'
import axios from "axios"
export default {
  name: 'App',
  components: {
    Menu,
  },

  data() {
    return {
      modalHasBeenOpened: false, 
      banner: {} // Tracks if modal has been opened
    }
  },

  async created() {
    document.title = 'Global Furniture Florida'
    let item
    let res = await axios.get("https://cdn.contentful.com/spaces/879w18cxw877/environments/master/entries?content_type=banners&access_token=k2d5BXs_CQ-Px-3YCdr-S28UtighsicKk5qERY1JuYg")
      .then(response => {
        return response.data
      })

    res.items.forEach(banner => {
      if(banner.fields.bannerId == 'ban2'){
        this.banner = banner.fields 
      }
    })

    console.log(this.banner)

    // Check cookie to see if modal was previously shown
    this.modalHasBeenOpened = this.getCookie('modalShown') === 'true'

    // Add click listener to show modal with 25% chance
    const showListener = (e) => {
      const modal = document.getElementById('modal')
      const isModalActive = modal.classList.contains('active')
      if (!this.modalHasBeenOpened && !isModalActive && Math.random() <= 0.5) {
        this.showModal()
      }
    }

    document.addEventListener('click', showListener)
    this.showListener = showListener  // Store for cleanup

  },

  methods: {
    showModal() {
      const modal = document.getElementById('modal')
      const backdrop = document.getElementById('modal-backdrop')
      modal.classList.add('active')
      backdrop.classList.add('active')
      this.modalHasBeenOpened = true  // Update local state
      this.setCookie('modalShown', 'true', 365)  // Set cookie for persistence

      // Remove show listener after modal is displayed
      document.removeEventListener('click', this.showListener)

      // Add listener to hide modal when clicking outside
      const hideListener = (e) => {
        const modal = document.getElementById('modal')
        if (modal.classList.contains('active') && 
            !modal.contains(e.target) && 
            !e.target.closest('.modal-inner')) {
          this.hideModal()
        }
      }
      document.addEventListener('click', hideListener)
      this.hideListener = hideListener  // Store for cleanup
    },

    hideModal() {
      const modal = document.getElementById('modal')
      const backdrop = document.getElementById('modal-backdrop')
      modal.classList.remove('active')
      backdrop.classList.remove('active')
      if(this.banner.redirectUrl){
        this.$router.push(this.banner.redirectUrl)
      }

    },

    // Set a cookie with name, value, and expiration in days
    setCookie(name, value, days) {
      let expires = ""
      if (days) {
        const date = new Date()
        date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000))
        expires = "; expires=" + date.toUTCString()
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/"
    },

    // Get a cookie by name
    getCookie(name) {
      const nameEQ = name + "="
      const ca = document.cookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
      }
      return null
    }
  },

  beforeDestroy() {
    // Clean up event listeners
    if (this.showListener) {
      document.removeEventListener('click', this.showListener)
    }
    if (this.hideListener) {
      document.removeEventListener('click', this.hideListener)
    }
  },

  async getBanner(bannerID){
    let item
    let res = await axios.get("https://cdn.contentful.com/spaces/879w18cxw877/environments/master/entries?content_type=banners&access_token=k2d5BXs_CQ-Px-3YCdr-S28UtighsicKk5qERY1JuYg")
      .then(response => {
        return response.data
      })

    res.items.forEach(banner => {
      if(banner.fields.bannerId == bannerID){
        item = banner.fields 
      }
    })
    console.log('executed')
     return item
  },
                   
}
</script>

<style scoped>
/* Base Styles */
.modal {
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 90%;
  max-width: 700px;
  height: auto;
  max-height: 90vh;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  overflow-y: auto;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
}

.modal.active {
  opacity: 1;
  display: flex;
}

.modal-backdrop.active {
  opacity: 1;
  pointer-events: auto;
}

.modal-image {
  width: 60%;
  height: auto;
  object-fit: cover;
}

.modal-inner {
  width: 40%;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  height: 100%; /* Fill modal height */
}

.modal-content {
  flex-grow: 1; /* Take up available space */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center content vertically */
  height: 100%;
}

.modal-title {
  font-size: clamp(1.5rem, 4vw, 1.8rem);
  font-weight: 400;
  color: #1a1a1a;
  margin: 0 0 1rem 0;
  font-family: 'Georgia', serif;
  letter-spacing: 0.5px;
  text-align: center;
}

.modal-text {
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  color: #4a4a4a;
  margin: 0;
  line-height: 1.6;
  font-family: 'Georgia', serif;
  text-align: center;
}

button {
  padding: 0.5rem 1.5rem;
  background-color: #1a1a1a;
  color: #fff;
  border: 1px solid #1a1a1a;
  border-radius: 0;
  font-size: clamp(0.8rem, 2vw, 0.9rem);
  font-weight: 500;
  font-family: 'Helvetica', 'Arial', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  cursor: pointer;
  align-self: center;
  margin-top: auto; /* Push to bottom */
  margin-bottom: 1rem; /* Margin below button */
}

#closeModal {
  margin-top: 3vh;
}

button:hover {
  background-color: #fff;
  color: #1a1a1a;
}

.modal:not(.active) {
  display: none;
}

/* Tablet (≤768px) */
@media (max-width: 768px) {
  .modal {
    flex-direction: column;
    width: 85%;
    max-width: 500px;
  }

  .modal-image {
    width: 100%;
    max-height: 50vh;
  }

  .modal-inner {
    width: 100%;
    padding: 1rem;
  }
}

/* Mobile (≤480px) */
@media (max-width: 480px) {
  .modal {
    width: 90%;
    max-width: 100%;
  }

  .modal-inner {
    padding: 0.75rem;
  }

  .modal-title {
    margin-bottom: 0.75rem;
  }

  button {
    padding: 0.4rem 1rem;
    margin-bottom: 0.75rem; /* Slightly smaller margin on mobile */
  }
}
</style>